// extracted by mini-css-extract-plugin
export default {"container":"InvoiceUpload_container__O0cJ-","root":"InvoiceUpload_root__8oaNE","subtitle":"InvoiceUpload_subtitle__yiCBI"};